// Configuration API centralisée
// nginx proxifie /api/ vers le backend depuis phoelynx.fr : les appels restent
// same-origin. En développement, VITE_API_URL pointe vers le backend local.
export const API_CONFIG = {
  BASE_URL: import.meta.env.VITE_API_URL || '/api',
  ENDPOINTS: {
    SERVICES: '/services',
    EVENTS: '/events',
    EVENTS_BY_TYPE: (type: string) => `/events/type/${type}`,
    PRODUCTS: '/products',
    PROJECTS: '/projects',
    ARTICLES: '/articles',
    // /settings est réservé aux administrateurs ; le site vitrine ne peut
    // consommer que la liste blanche exposée par /settings/public.
    SETTINGS: '/settings/public',
    // Compteurs recalculés à chaque appel depuis la base.
    STATS: '/stats/public',
    // Témoignages publiés (email exclu côté serveur).
    TESTIMONIALS: '/testimonials/public',
    // Passage de commande (checkout).
    CHECKOUT: '/orders/checkout',
    HEALTH: '/health'
  }
};

// Helper pour construire les URLs complètes
export const buildApiUrl = (endpoint: string): string => {
  return `${API_CONFIG.BASE_URL}${endpoint}`;
};